import React from 'react';
import type { FilterSearchPropsMenu } from '@components';
import { toggleItemAtPath } from '@components/filter-checkbox-selector/helpers.ts';
import {
    DropDownMenuRightItems,
    DropDownMenuRightItemsInnerWrapper,
    DropDownMenuRollout,
    MenuLeftItemText,
    MenuRightItem,
} from '@components/filter-checkbox-selector/styled.ts';
import { BaseRadio, BaseRadioGroup } from '@components/radio';
import { translateItem } from '@utils/translations.ts';

interface Props {
    menu: FilterSearchPropsMenu[];
    level: number;
    items: FilterSearchPropsMenu[];
    activePath: number[];
    onCheckboxSelected?: (
        path: number[] | number[][],
        checked: boolean,
        overriddenMenu?: FilterSearchPropsMenu[],
    ) => void;
}

const RadioMenuType: React.FC<Props> = ({ menu, level, items, activePath, onCheckboxSelected }) => {
    const handleRadioItemClick = (items: FilterSearchPropsMenu[], itemIndex: number) => {
        const selectedIndex = items.findIndex((item) => item.isSelected);
        const noItemsSelectedMenu = toggleItemAtPath(menu, [...activePath, selectedIndex], false);

        if (selectedIndex !== itemIndex) {
            onCheckboxSelected?.([...activePath, itemIndex], true, noItemsSelectedMenu);
        }
    };

    const selectedItem = items.find((item) => item.isSelected);

    return (
        <DropDownMenuRollout key={level}>
            <DropDownMenuRightItems>
                <DropDownMenuRightItemsInnerWrapper>
                    <BaseRadioGroup value={selectedItem?.name}>
                        {items.map((opt, i) => (
                            <MenuRightItem
                                key={opt.name}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleRadioItemClick(items, i);
                                }}
                            >
                                <BaseRadio value={opt.name}>
                                    <MenuLeftItemText>{translateItem(opt.displayName as string)}</MenuLeftItemText>
                                </BaseRadio>
                            </MenuRightItem>
                        ))}
                    </BaseRadioGroup>
                </DropDownMenuRightItemsInnerWrapper>
            </DropDownMenuRightItems>
        </DropDownMenuRollout>
    );
};

export default RadioMenuType;
